import React from 'react'

const Label = ({ name, children }) => (
  <label htmlFor={name} className="text-sm text-gray-800 mb-2 block">{children}</label>
)

export default Label
